module.exports = __webpack_public_path__ + "img/3m.03b2f4d9.jpg";